import { render, staticRenderFns } from "./QrCodeStyling.vue?vue&type=template&id=1ce18fe7&scoped=true&"
import script from "./QrCodeStyling.vue?vue&type=script&lang=ts&"
export * from "./QrCodeStyling.vue?vue&type=script&lang=ts&"
import style0 from "./QrCodeStyling.vue?vue&type=style&index=0&id=1ce18fe7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce18fe7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
